import React from "react";
import { Card, Image } from "semantic-ui-react";

import "./_style.scss";

const imageUrl = "/armo.jpg";
function SimpleCard() {
  return (
    <Card.Group itemsPerRow={4} doubling centered className="m_simple-item">
      <Card className="card-item">
        <Image src={imageUrl} wrapped ui={false} className="img" />
        <label className="lbl-card-status">5 hrs ago</label>
        <Card.Content className="content">
          <Card.Content>
            <h5>Armo Compound</h5>
          </Card.Content>
          <Card.Content>
            <span className="farm">Maw Maw Farming Supplies</span>
          </Card.Content>
          <Card.Content>
            <span className="price">30000 MMK</span>
          </Card.Content>
        </Card.Content>
      </Card>
      <Card className="card-item">
        <Image src={imageUrl} wrapped ui={false} className="img" />
        <label className="lbl-card-status">5 hrs ago</label>
        <Card.Content className="content">
          <Card.Content>
            <h5>Armo Compound</h5>
          </Card.Content>
          <Card.Content>
            <span className="farm">Maw Maw Farming Supplies</span>
          </Card.Content>
          <Card.Content>
            <span className="price">30000 MMK</span>
          </Card.Content>
        </Card.Content>
      </Card>

      <Card className="card-item">
        <Image src={imageUrl} wrapped ui={false} className="img" />
        <label className="lbl-card-status">5 hrs ago</label>
        <Card.Content className="content">
          <Card.Content>
            <h5>Armo Compound</h5>
          </Card.Content>
          <Card.Content>
            <span className="farm">Maw Maw Farming Supplies</span>
          </Card.Content>
          <Card.Content>
            <span className="price">30000 MMK</span>
          </Card.Content>
        </Card.Content>
      </Card>
      <Card className="card-item">
        <Image src={imageUrl} wrapped ui={false} className="img" />
        <label className="lbl-card-status">5 hrs ago</label>
        <Card.Content className="content">
          <Card.Content>
            <h5>Armo Compound</h5>
          </Card.Content>
          <Card.Content>
            <span className="farm">Maw Maw Farming Supplies</span>
          </Card.Content>
          <Card.Content>
            <span className="price">30000 MMK</span>
          </Card.Content>
        </Card.Content>
      </Card>

      <Card className="card-item">
        <Image src={imageUrl} wrapped ui={false} className="img" />
        <label className="lbl-card-status">5 hrs ago</label>
        <Card.Content className="content">
          <Card.Content>
            <h5>Armo Compound</h5>
          </Card.Content>
          <Card.Content>
            <span className="farm">Maw Maw Farming Supplies</span>
          </Card.Content>
          <Card.Content>
            <span className="price">30000 MMK</span>
          </Card.Content>
        </Card.Content>
      </Card>

      <Card className="card-item">
        <Image src={imageUrl} wrapped ui={false} className="img" />
        <label className="lbl-card-status">5 hrs ago</label>
        <Card.Content className="content">
          <Card.Content>
            <h5>Armo Compound</h5>
          </Card.Content>
          <Card.Content>
            <span className="farm">Maw Maw Farming Supplies</span>
          </Card.Content>
          <Card.Content>
            <span className="price">30000 MMK</span>
          </Card.Content>
        </Card.Content>
      </Card>

      <Card className="card-item">
        <Image src={imageUrl} wrapped ui={false} className="img" />
        <label className="lbl-card-status">5 hrs ago</label>
        <Card.Content className="content">
          <Card.Content>
            <h5>Armo Compound</h5>
          </Card.Content>
          <Card.Content>
            <span className="farm">Maw Maw Farming Supplies</span>
          </Card.Content>
          <Card.Content>
            <span className="price">30000 MMK</span>
          </Card.Content>
        </Card.Content>
      </Card>

      <Card className="card-item">
        <Image src={imageUrl} wrapped ui={false} className="img" />
        <label className="lbl-card-status">5 hrs ago</label>
        <Card.Content className="content">
          <Card.Content>
            <h5>Armo Compound</h5>
          </Card.Content>
          <Card.Content>
            <span className="farm">Maw Maw Farming Supplies</span>
          </Card.Content>
          <Card.Content>
            <span className="price">30000 MMK</span>
          </Card.Content>
        </Card.Content>
      </Card>

      <Card className="card-item">
        <Image src={imageUrl} wrapped ui={false} className="img" />
        <label className="lbl-card-status">5 hrs ago</label>
        <Card.Content className="content">
          <Card.Content>
            <h5>Armo Compound</h5>
          </Card.Content>
          <Card.Content>
            <span className="farm">Maw Maw Farming Supplies</span>
          </Card.Content>
          <Card.Content>
            <span className="price">30000 MMK</span>
          </Card.Content>
        </Card.Content>
      </Card>

      <Card className="card-item">
        <Image src={imageUrl} wrapped ui={false} className="img" />
        <label className="lbl-card-status">5 hrs ago</label>
        <Card.Content className="content">
          <Card.Content>
            <h5>Armo Compound</h5>
          </Card.Content>
          <Card.Content>
            <span className="farm">Maw Maw Farming Supplies</span>
          </Card.Content>
          <Card.Content>
            <span className="price">30000 MMK</span>
          </Card.Content>
        </Card.Content>
      </Card>

      <Card className="card-item">
        <Image src={imageUrl} wrapped ui={false} className="img" />
        <label className="lbl-card-status">5 hrs ago</label>
        <Card.Content className="content">
          <Card.Content>
            <h5>Armo Compound</h5>
          </Card.Content>
          <Card.Content>
            <span className="farm">Maw Maw Farming Supplies</span>
          </Card.Content>
          <Card.Content>
            <span className="price">30000 MMK</span>
          </Card.Content>
        </Card.Content>
      </Card>

      <Card className="card-item">
        <Image src={imageUrl} wrapped ui={false} className="img" />
        <label className="lbl-card-status">5 hrs ago</label>
        <Card.Content className="content">
          <Card.Content>
            <h5>Armo Compound</h5>
          </Card.Content>
          <Card.Content>
            <span className="farm">Maw Maw Farming Supplies</span>
          </Card.Content>
          <Card.Content>
            <span className="price">30000 MMK</span>
          </Card.Content>
        </Card.Content>
      </Card>
    </Card.Group>
  );
}

export default SimpleCard;
